import { ChannelMessageStatus } from "@wingspanhq/notifications/dist/lib/interfaces";
import {
  useModalContext,
  useWSSnackbar,
  WSButton
} from "@wingspanhq/fe-component-library";
import { TIN_VERIFICATION_MODAL } from "../../../../../Invoices/components/TINVerificationModal/TINVerificationModal";
import React from "react";
import { NotificationTemplate } from "../index";

export const TINVerification: NotificationTemplate<never> = {
  renderTitle: props => "Invalid TIN and name",
  renderBody: props => {
    return "Your name and the TIN you provided could not be matched by the IRS. Please re-enter your TIN and name to continue with the onboarding process and get paid.";
  },
  Footer: props => {
    const { openModal, closeModal } = useModalContext();
    const { openSnackbar } = useWSSnackbar();

    return (
      <WSButton.Link
        size="S"
        rightIcon="chevron-right"
        onClick={() => {
          openModal(TIN_VERIFICATION_MODAL, {
            onContinue: () => {
              closeModal(TIN_VERIFICATION_MODAL);
              openSnackbar({
                type: "success",
                duration: 3000,
                message: `Information submitted`
              });
            }
          });
        }}
      >
        Validate TIN
      </WSButton.Link>
    );
  }
};
